<div class="flex w-full items-center gap-2 mb-4">
  <app-back-button [url]="'/'" />
  <h1
    class="pr-9 text-3xl max-w-full whitespace-nowrap overflow-hidden lg:text-5xl lg:leading-[120%]"
    id="forgotPasswordFormHeading"
  >
    Wachtwoord vergeten
  </h1>
</div>

@if (requestSend) {
  <app-card class="block w-full mt-6 mb-9">
    <p>
      Er is een e-mail verstuurd met een link om je wachtwoord te resetten. Controleer je inbox (en eventueel je
      spamfolder).
    </p>
  </app-card>
} @else {
  <form
    [formGroup]="forgotPasswordForm"
    (ngSubmit)="onSubmit()"
    role="form"
    aria-labelledby="forgotPasswordFormHeading"
  >
    <app-card class="block w-full mt-6 mb-9">
      @if (error) {
        <p class="text-red-500 text-center mb-4" role="alert">
          {{ error }}
        </p>
      }
      <div class="custom-input-container mt-4 w-full">
        <label class="custom-label" for="email">E-mailadres</label>
        <mat-form-field appearance="outline">
          <input
            id="email"
            matInput
            type="email"
            formControlName="email"
            placeholder="Jouw e-mailadres"
            autocomplete="email"
            aria-describedby="emailError"
          />
          <mat-error id="emailError" role="alert">Vul een geldige email in.</mat-error>
        </mat-form-field>
      </div>
    </app-card>
    <div class="flex justify-end mb-4">
      <button
        mat-flat-button
        color="accent"
        type="submit"
        [disabled]="forgotPasswordForm.invalid || isLoading"
        class="w-full button-large"
      >
        Verzenden
      </button>
    </div>

    <div class="mt-4">
      <app-logo-images></app-logo-images>
    </div>
  </form>
}
